function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "pressTitle"
}, "press");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M35.826 36.929L42.11 43.2 28.284 57 22 50.728l13.826-13.8zm4.916-7.395l8.777 8.76-4.47 4.462-8.778-8.76 4.47-4.462zm15.236-5.516c2.696 2.69 2.696 7.053 0 9.743-1.528 1.525-3.593 2.186-5.587 1.982l-6.16-6.15c-.204-1.99.458-4.05 1.985-5.575 2.696-2.69 7.067-2.69 9.762 0z",
  transform: "translate(-292 -650) translate(292 650)"
}))));

var SvgPrimaryButtonUiPressIcon = function SvgPrimaryButtonUiPressIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    "aria-labelledby": "pressTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "pressTitle"
  }, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrimaryButtonUiPressIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/primary-button-ui-press-icon.9ff05ff6.svg";
export { ForwardRef as ReactComponent };